import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	createdInvoice: { error: null, loading: false, data: null },
	invoiceById: { error: null, loading: false, data: null }
};

const { actions, reducer } = createSlice({
	name: 'invoices',
	initialState,
	reducers: {
		createInvoice: (state, { payload }) => {
			state.createdInvoice = {
				...state.createdInvoice.invoice,
				error: null,
				loading: true,
			};
		},
		createInvoiceFailure: (state, { payload }) => {
			state.createdInvoice = {
				...state.createdInvoice,
				error: payload,
				loading: false,
			};
		},
		createInvoiceSuccess: (state, { payload }) => {
			state.createdInvoice = {
				...state.createdInvoice,
				data: payload.invoice ?? payload,
				error: null,
				loading: false,
			};
		},
		getInvoiceById: (state) => {
			state.invoiceById = {
				...state.invoiceById,
				loading: true,
				error: null,
			};
		},
		getInvoiceByIdSuccess: (state, { payload }) => {
			state.invoiceById = {
				data: payload,
				loading: false,
				error: null,
			};
		},
		getInvoiceByIdFailure: (state, { payload }) => {
			state.invoiceById = {
				...state.invoiceById,
				loading: false,
				error: payload,
			};
		},
	}
});

export const { createInvoice, createInvoiceFailure, createInvoiceSuccess, getInvoiceById, getInvoiceByIdFailure, getInvoiceByIdSuccess } = actions;

export { default as invoicesSaga } from './sagas';

export default reducer;
